import React, { FormEvent, Fragment, useContext, useEffect, useState } from "react";
import {
  Grid,
  Segment,
  Form,
  Button,
  Popup,
} from "semantic-ui-react";
import FttbHourList from "./FttbHourList";
import { observer } from "mobx-react-lite";
import FttbHourStore from "../../../app/stores/fttbhourStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";

const FttbHourDashboard: React.FC = () => {
  const fttbhourStore = useContext(FttbHourStore);
  const {
    submitting,
    loadFttbHourTechs,
    searchFttbHours,
    fttbhourTech,
    loadPayrollCycles,
    payrollcyclesByName,
    payrollcycleRegistry,
    fttbhournamesByDate,
  } = fttbhourStore;

  useEffect(() => {
    loadFttbHourTechs();
    loadPayrollCycles();
  }, []);

  const [search, setSearch] = useState({
    tech: "",
    payRun: "",
    jobStartDate: "",
    jobEndDate: "",
    orderNo: "",
  });

  if (fttbhourStore.loadingInitial)
    return <LoadingComponent content="Loading FttbHours" />;

  const techOptions = fttbhourTech.map(function (tech) {
    var option = { key: tech.tech, text: tech.tech, value: tech.tech };
    return option;
  });

  const payrunOptions = payrollcyclesByName.map(function (payrun) {
    var option = { key: payrun.startYear+payrun.endYear+payrun.payRun, 
                  text: payrun.startYear+'-'+payrun.endYear+' '+payrun.payRun, 
                 value: payrun.startYear+'-'+payrun.endYear+'-'+payrun.payRun };
    return option;
  });

  const handleSubmit = () => {
    searchFttbHours(search);
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setSearch({ ...search, [name]: value });
  };

  return (
    <Segment>

          <Form onSubmit={handleSubmit}>
          <Grid>
          <Grid.Column width={3}>
            <Form.Select
              label="Tech"
              onChange={(e, { name, value }) =>
                setSearch({ ...search, [name]: value })
              }
              options={techOptions}
              search
              name="tech"
              placeholder="Tech"
              value={search.tech}
              clearable
              width={3}
            />
            </Grid.Column>
            <Grid.Column width={2}>

            </Grid.Column>
            <Grid.Column width={3}>
              <Form.Select
              label="Pay Run"
              onChange={(e, { name, value }) =>
                setSearch({ ...search, [name]: value })
              }
              options={payrunOptions}
              search
              name="payRun"
              placeholder="Pay Run"
              value={search.payRun}
              clearable
            />
           </Grid.Column>
           <Grid.Column width={5}>
            <div style={{marginTop: '2.2rem'}}>&nbsp;&nbsp;
            {(payrollcycleRegistry.get(search.payRun)) && 'From:\xa0\xa0' + payrollcycleRegistry.get(search.payRun).startDate.substr(0,10) } 
            &nbsp;&nbsp;&nbsp;&nbsp;
            {(payrollcycleRegistry.get(search.payRun)) && 'To:\xa0\xa0' + payrollcycleRegistry.get(search.payRun).endDate.substr(0,10)} 
            </div>
            </Grid.Column>
            </Grid>
            <Grid>
            <Grid.Column width={3}>
            <Form.Input
          label='Job Start Date'
          onChange={handleInputChange}
          name='jobStartDate'
          type='date'
          placeholder='Date'
          clearable
          value={search.jobStartDate}
        />
           </Grid.Column>
           <Grid.Column width={3}>
            <Form.Input
          label='Job End Date'
          onChange={handleInputChange}
          name='jobEndDate'
          type='date'
          placeholder='Date'
          clearable
          value={search.jobEndDate}
        />
           </Grid.Column>
            </Grid>
            <Grid>
            <Grid.Column width={3}>
            <Form.Input
          label='Work Order No.'
          onChange={handleInputChange}
          name='orderNo'
          placeholder='Work Order No.'
          value={search.orderNo}
        />
        </Grid.Column>
        </Grid>
             <br/>
            <Button
              loading={submitting}
              floated="left"
              positive
              type="submit"
              content="Search"
            />
          </Form>
          

      <Grid> 
      <Grid.Column width={13}>
      <CSVLink data={fttbhournamesByDate}  filename={"FTTB Payment List.csv"}>
      <Popup content='Download as CSV' trigger={<Button icon='download' floated='left' />} />
      </CSVLink>
      </Grid.Column>
        <Grid.Column textAlign="center" width={3}>
          <Button
            as={Link}
            to={`/financemanagement/fttbhour-create`}
            color="linkedin"
            icon="add"
            content="Create New"
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <FttbHourList />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default observer(FttbHourDashboard);
